import { SurfaceType } from "../../gql-generated/types";

interface SurfaceTypeDisplayMeta {
    name: string;
}

export const lensSurfaceTypeMap: Record<SurfaceType, SurfaceTypeDisplayMeta> = {
    [SurfaceType.SurfaceTypeSnapchat]: { name: "Snapchat" },
    [SurfaceType.SurfaceTypeSpectacles]: { name: "Spectacles" },
    [SurfaceType.SurfaceTypeUnset]: { name: "N/A" },
};
